export default "__VITE_ASSET__CypFxJ0V__"